"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _get = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PointRegion = void 0;

var Region_1 = require("../Region");

var DragElement_1 = require("./DragElement");

var TagsElement_1 = require("./TagsElement");
/**
 * The point-type region class.
 */


var PointRegion = /*#__PURE__*/function (_Region_1$Region) {
  _inherits(PointRegion, _Region_1$Region);

  /**
   * Creates new `PointRegion` object.
   * @param paper - The `Snap.Paper` object to draw on.
   * @param paperRect - The parent bounding box for created component.
   * @param regionData - The `RegionData` object shared across components. Used also for initial setup.
   * @param callbacks - The external callbacks collection.
   * @param id - The region `id` used to identify regions in `RegionsManager`.
   * @param tagsDescriptor - The descriptor of region tags.
   * @param tagsUpdateOptions - The drawing options for tags.
   */
  function PointRegion(paper) {
    var _this;

    var paperRect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var regionData = arguments.length > 2 ? arguments[2] : undefined;
    var callbacks = arguments.length > 3 ? arguments[3] : undefined;
    var id = arguments.length > 4 ? arguments[4] : undefined;
    var tagsDescriptor = arguments.length > 5 ? arguments[5] : undefined;
    var tagsUpdateOptions = arguments.length > 6 ? arguments[6] : undefined;

    _classCallCheck(this, PointRegion);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PointRegion).call(this, paper, paperRect, regionData, callbacks, id, tagsDescriptor, tagsUpdateOptions));

    _this.buildOn(paper);

    return _this;
  }
  /**
   * Updates region tags.
   * @param tags - The new tags descriptor object.
   * @param options - The tags drawing options.
   */


  _createClass(PointRegion, [{
    key: "updateTags",
    value: function updateTags(tags, options) {
      _get(_getPrototypeOf(PointRegion.prototype), "updateTags", this).call(this, tags, options);

      this.tagsNode.updateTags(tags, options);
      this.node.select("title").node.innerHTML = tags !== null ? tags.toString() : "";
    }
    /**
     * Creates the UI of the region component.
     * @param paper - The `Snap.Paper` element to draw on.
     */

  }, {
    key: "buildOn",
    value: function buildOn(paper) {
      this.node = paper.g();
      this.node.addClass("regionStyle");
      this.node.addClass(this.styleID);
      this.dragNode = new DragElement_1.DragElement(paper, this.paperRect, this.regionData, this.callbacks);
      this.tagsNode = new TagsElement_1.TagsElement(paper, this.paperRect, this.regionData, this.tags, this.styleID, this.styleSheet, this.tagsUpdateOptions);
      this.toolTip = Snap.parse("<title>".concat(this.tags !== null ? this.tags.toString() : "", "</title>"));
      this.node.append(this.toolTip);
      this.node.add(this.dragNode.node);
      this.node.add(this.tagsNode.node);
      this.UI.push(this.tagsNode, this.dragNode);
    }
  }]);

  return PointRegion;
}(Region_1.Region);

exports.PointRegion = PointRegion;